import { t } from 'i18next';

import { IOption } from 'core/types';

// The arguments resetPricingAction takes after the rows: cost, price, excludeCustom.
type TResetPricingArgs = [cost: boolean, price?: boolean, excludeCustom?: boolean];

/**
 * An excluding variant keeps its plain one's label and says what it keeps in a second line.
 */
export const getResetPricingOptions = ({
  onReset,
  disabled,
}: {
  onReset: (...args: TResetPricingArgs) => void;
  disabled?: boolean;
}): IOption[] =>
  [
    { labelKey: 'labelResetCost', args: [true] },
    {
      labelKey: 'labelResetCost',
      descriptionKey: 'labelExcludeManuallyEnteredAndSelectedSpa',
      args: [true, false, true],
    },
    { labelKey: 'labelResetPrice', args: [false, true] },
    {
      labelKey: 'labelResetPrice',
      descriptionKey: 'labelExcludeManuallyEntered',
      args: [false, true, true],
    },
    { labelKey: 'labelResetCostAndPrice', args: [true, true] },
    {
      labelKey: 'labelResetCostAndPrice',
      descriptionKey: 'labelExcludeManuallyEnteredAndSelectedSpa',
      args: [true, true, true],
    },
  ].map(({ labelKey, descriptionKey, args }) => ({
    label: t(labelKey),
    ...(descriptionKey ? { description: t(descriptionKey) } : {}),
    onClick: () => onReset(...(args as TResetPricingArgs)),
    disabled,
  }));
